import React, { Component } from 'react'
import Panel from './../../components/Panel'

import LoginContainer from './../../containers/LoginContainer'

class Login extends Component {
  render () {
    return (
      <div className='login'>
        <Panel
          featurePanel
          mainPanel={<LoginContainer className='main-panel__form' />}
        />
      </div>
    )
  }
}

export default Login



// WEBPACK FOOTER //
// ./src/routes/Login/index.js